/* LAMY 1.2 (08/10/2026) — trang sản phẩm: thư viện ảnh vuốt, nút chọn phân loại, thanh mua dính dưới màn hình. */
(function () {
  'use strict';
  var money = function (cents) {
    return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + 'đ';
  };
  var data = { variants: [] };
  try { data = JSON.parse(document.getElementById('lp-product-json').textContent); } catch (e) {}

  /* ---------- 1. Thư viện ảnh ---------- */
  var gal = document.querySelector('[data-lp-gal]');
  if (gal) {
    var track = gal.querySelector('[data-lp-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.lp-gal__thumb'));
    var count = gal.querySelector('[data-lp-count]');
    var thumbBox = gal.querySelector('[data-lp-thumbs]');
    var cur = -1;
    var mark = function (i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var t = thumbs[i];
      if (t && thumbBox) {
        if (thumbBox.scrollHeight > thumbBox.clientHeight + 4) {
          thumbBox.scrollTo({ top: Math.max(0, t.offsetTop - thumbBox.clientHeight / 2 + t.clientHeight / 2), behavior: 'smooth' });
        } else {
          thumbBox.scrollTo({ left: Math.max(0, t.offsetLeft - thumbBox.clientWidth / 2 + t.clientWidth / 2), behavior: 'smooth' });
        }
      }
    };
    var go = function (i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      lockUntil = Date.now() + 700;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    };
    var lockUntil = 0;
    track.addEventListener('scroll', function () {
      if (Date.now() < lockUntil) return;
      var w = track.clientWidth || 1;
      mark(Math.round(track.scrollLeft / w));
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = gal.querySelector('[data-lp-prev]');
    var next = gal.querySelector('[data-lp-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
    var start = parseInt(gal.getAttribute('data-start') || '0', 10) || 0;
    mark(start);
    if (start) requestAnimationFrame(function () { go(start, false); });
    window.lpGal = {
      go: go,
      goMedia: function (id) {
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return true; }
        }
        return false;
      }
    };
  }

  /* ---------- 2. Nút chọn phân loại (thay ô thả xuống) ---------- */
  var form = document.getElementById('AddToCartForm');
  /* Màu → chấm màu (kim loại trước, màu đá sau). Không nhận ra màu thì dùng ảnh của phân loại. */
  var COLORS = [
    ['vàng hồng', '#e7b29d'], ['rose gold', '#e7b29d'], ['xanh dương', '#5b8def'], ['xanh lá', '#4caf7a'], ['xanh ngọc', '#3fb8af'],
    ['mắt hổ', '#b8742a'], ['xà cừ', '#ece6dc'], ['ngọc trai', '#f3ece0'],
    ['bạc', '#cfd2d8'], ['silver', '#cfd2d8'], ['vàng', '#e2c06b'], ['gold', '#e2c06b'], ['đen', '#26222a'], ['trắng', '#ffffff'],
    ['đỏ', '#c62f3b'], ['hồng', '#f2a6bb'], ['tím', '#9c6ade'], ['cam', '#f2994a'], ['nâu', '#8d5b3e'], ['xám', '#9e9ea4'], ['xanh', '#5b8def']
  ];
  /* Lấy mọi màu có trong tên (cụm dài trước), xếp theo vị trí xuất hiện, giữ 2 màu đầu: kim loại rồi màu đá. */
  var colorsOf = function (val) {
    var t = ' ' + val.toLowerCase() + ' ', out = [];
    COLORS.forEach(function (c) {
      var k = t.indexOf(c[0]);
      if (k > -1) { out.push([k, c[1]]); t = t.slice(0, k) + ' '.repeat(c[0].length) + t.slice(k + c[0].length); }
    });
    return out.sort(function (a, b) { return a[0] - b[0]; }).slice(0, 2).map(function (x) { return x[1]; });
  };
  /* Số cột lưới: chọn số cột (2..max) để hàng cuối ít ô trống nhất, hoà thì lấy nhiều cột hơn. */
  var pickCols = function (n, max) {
    if (n <= 1) return Math.min(2, max);
    var best = 2, bestEmpty = 99;
    for (var c = 2; c <= Math.min(max, n); c++) {
      var empty = Math.ceil(n / c) * c - n;
      if (empty <= bestEmpty) { best = c; bestEmpty = empty; }
    }
    return best;
  };
  var colorNames = /^(màu|mau|color|colour|màu sắc|kiểu|kieu|style|loại|phân loại)$/i; /* kiểu/loại: không ra màu thì dùng ảnh */
  var sizeModal = null;
  var openSizeGuide = function (url) {
    if (!sizeModal) {
      sizeModal = document.createElement('div');
      sizeModal.className = 'lp-sg';
      sizeModal.innerHTML = '<div class="lp-sg__shade" data-close></div><div class="lp-sg__box" role="dialog" aria-modal="true" aria-label="Cách đo size nhẫn"><button type="button" class="lp-sg__x" data-close aria-label="Đóng">×</button><div class="lp-sg__body">Đang tải…</div></div>';
      document.body.appendChild(sizeModal);
      sizeModal.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close')) sizeModal.classList.remove('is-on'); });
      fetch(url).then(function (r) { return r.text(); }).then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html');
        var lsg = d.querySelector('.lsg');
        if (lsg) { var bd = sizeModal.querySelector('.lp-sg__body'); bd.innerHTML = ''; bd.appendChild(document.importNode(lsg, true)); return; }
        var t = d.querySelector('table');
        var box = t ? t.closest('.rte, .page-content, .content, main') || t.parentNode : null;
        var body = sizeModal.querySelector('.lp-sg__body');
        if (box) { body.innerHTML = ''; box.querySelectorAll('h2, h3, p, table').forEach(function (n) { if (!n.querySelector('img')) body.appendChild(n.cloneNode(true)); });  var tb = body.querySelector('table'), h = body.querySelector('h2'); if (tb && h) { var note = document.createElement('p'); note.textContent = 'Đo chu vi ngón tay (mm) rồi đối chiếu bảng dưới. Cách đo ở phía sau.'; h.after(note); note.after(tb); } }
        else { body.innerHTML = '<p><a href="' + url + '">Xem hướng dẫn đo size</a></p>'; }
      });
    }
    sizeModal.classList.add('is-on');
  };
  var pills = [];
  var selectedOf = function () {
    return pills.map(function (p) { return p.select.value; });
  };
  /* Còn hàng không: biến thể có giá trị `val` ở tuỳ chọn idx, các tuỳ chọn khác khớp lựa chọn hiện tại. */
  var availableWith = function (idx, val, sel) {
    return data.variants.some(function (v) {
      if (!v.available || v.options[idx] !== val) return false;
      for (var j = 0; j < sel.length; j++) { if (j !== idx && v.options[j] !== sel[j]) return false; }
      return true;
    });
  };
  var refresh = function () {
    var sel = selectedOf();
    pills.forEach(function (p, idx) {
      if (p.combo) { p.combo.refresh(sel, idx); return; }
      p.label.textContent = p.name + ': ';
      p.value.textContent = p.show ? p.show(p.select.value) : p.select.value;
      p.buttons.forEach(function (b) {
        var val = b.getAttribute('data-value');
        b.classList.toggle('is-on', val === p.select.value);
        b.setAttribute('aria-pressed', val === p.select.value ? 'true' : 'false');
        b.classList.toggle('is-out', !availableWith(idx, val, sel));
      });
    });
  };
  var choose = function (select, val) {
    lpUser = true;
    if (!val || select.value === val) return;
    select.value = val;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    if (window.jQuery) window.jQuery(select).trigger('change');
    refresh();
  };
  var dotEl = function (txt) {
    var dots = colorsOf(txt);
    if (!dots.length) return null;
    var d = document.createElement('span');
    d.className = 'lp-dot';
    d.style.background = dots.length > 1
      ? 'linear-gradient(135deg,' + dots[0] + ' 0 50%,' + dots[1] + ' 50% 100%)'
      : 'radial-gradient(circle at 35% 30%, rgba(255,255,255,.75), rgba(255,255,255,0) 45%), ' + dots[0];
    return d;
  };
  var makeHead = function () {
    var head = document.createElement('div'); head.className = 'lp-opt__head';
    var l = document.createElement('span'); l.className = 'lp-opt__name';
    var v = document.createElement('span'); v.className = 'lp-opt__val';
    head.appendChild(l); head.appendChild(v);
    return { head: head, l: l, v: v };
  };
  /* Lưới nút: items = [{key, text, dot, img}], onPick(key). Số cột theo độ dài chữ và số nút. */
  var makeList = function (name, items, isColor, onPick) {
    var list = document.createElement('div');
    list.className = 'lp-opt__list';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-label', name);
    var maxLen = Math.max.apply(null, items.map(function (x) { return x.text.length; }).concat([1]));
    var chip = !isColor && maxLen <= 3;
    var mM = chip ? 6 : maxLen <= 9 ? 3 : 2;
    var mD = chip ? 7 : maxLen <= 12 ? 3 : 2;
    if (chip) list.classList.add('lp-opt__list--chip');
    var cm = pickCols(items.length, mM);
    if (isColor && cm === 3) list.classList.add('lp-opt__list--tight');
    list.style.setProperty('--lp-cm', cm);
    list.style.setProperty('--lp-cd', pickCols(items.length, mD));
    var buttons = items.map(function (it) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lp-pill';
      b.setAttribute('data-value', it.key);
      if (it.dot) b.appendChild(it.dot);
      else if (it.img) { var im = document.createElement('img'); im.src = it.img; im.alt = ''; im.width = 28; im.height = 28; im.loading = 'lazy'; b.appendChild(im); }
      var t = document.createElement('span'); t.textContent = it.text; b.appendChild(t);
      b.addEventListener('click', function () { onPick(it.key); });
      list.appendChild(b);
      return b;
    });
    return { list: list, buttons: buttons };
  };
  var buildPills = function () {
    if (!form || form.getAttribute('data-lp-pills')) return true;
    var wrappers = form.querySelectorAll('.selector-wrapper');
    if (!wrappers.length) return false;
    var visible = Array.prototype.filter.call(wrappers, function (w) { return w.style.display !== 'none' && w.querySelector('select'); });
    if (!visible.length) { form.setAttribute('data-lp-pills', '1'); return true; }
    form.setAttribute('data-lp-pills', '1');
    visible.forEach(function (w, idx) {
      var select = w.querySelector('select');
      var lab = w.querySelector('label');
      var name = (lab ? lab.textContent : select.getAttribute('data-option') || '').trim();
      var vals = Array.prototype.filter.call(select.options, function (o) { return o.value; }).map(function (o) { return o.value; });
      var isColor = colorNames.test(name);
      /* Nhóm "Kiểu / Phân loại" không chứa tên màu (vd chữ cái) thì hiện dạng chữ, không ảnh nhỏ. */
      if (isColor && !/^(màu|mau|màu sắc|color|colour)$/i.test(name) && !vals.some(function (x) { return colorsOf(x).length; })) isColor = false;
      var box = document.createElement('div');
      box.className = 'lp-opt' + (isColor ? ' lp-opt--color' : '');
      w.classList.add('lp-sr');
      w.parentNode.insertBefore(box, w);
      select.addEventListener('change', refresh);

      /* 1. Chỉ có 1 lựa chọn: chỉ hiện dòng "Màu: Bạc", không hiện nút. */
      if (vals.length === 1) {
        var h1 = makeHead(); box.classList.add('lp-opt--single'); box.appendChild(h1.head);
        pills.push({ select: select, name: name, label: h1.l, value: h1.v, buttons: [] });
        return;
      }

      /* 2. Giá trị dạng "Kim loại, đá X": tách thành 2 hàng Màu kim loại / Màu đá. */
      var parts = vals.map(function (x) { var m = x.match(/^\s*([^,]+?)\s*,\s*(?:đá\s+)?(.+?)\s*$/i); return m ? [m[1], m[2]] : null; });
      if (isColor && vals.length >= 3 && parts.every(Boolean)) {
        var metals = [], stones = [], key = {};
        parts.forEach(function (pp, i) { if (metals.indexOf(pp[0]) < 0) metals.push(pp[0]); if (stones.indexOf(pp[1]) < 0) stones.push(pp[1]); key[pp[0] + '|' + pp[1]] = vals[i]; });
        if (stones.length >= 2) {
          var cur = function () { var i = vals.indexOf(select.value); return i > -1 ? parts[i] : parts[0]; };
          var pickBy = function (m, st) {
            var sel = selectedOf(), exact = key[m + '|' + st];
            if (exact && availableWith(idx, exact, sel)) return exact;
            var pool = vals.filter(function (x, i) { return parts[i][0] === m; });
            if (st !== cur()[1]) pool = vals.filter(function (x, i) { return parts[i][1] === st; });
            return pool.filter(function (x) { return availableWith(idx, x, sel); })[0] || exact || pool[0];
          };
          var hm = makeHead(), hs = makeHead();
          var lm = makeList('Màu kim loại', metals.map(function (m) { return { key: m, text: m, dot: dotEl(m) }; }), true, function (m) { choose(select, pickBy(m, cur()[1])); });
          var ls = makeList('Màu đá', stones.map(function (st) { return { key: st, text: st.charAt(0).toUpperCase() + st.slice(1), dot: dotEl(st) }; }), true, function (st) { choose(select, pickBy(cur()[0], st)); });
          var sub1 = document.createElement('div'); sub1.className = 'lp-opt__sub'; sub1.appendChild(hm.head); sub1.appendChild(lm.list);
          var sub2 = document.createElement('div'); sub2.className = 'lp-opt__sub'; sub2.appendChild(hs.head); sub2.appendChild(ls.list);
          box.classList.add('lp-opt--combo'); box.appendChild(sub1); box.appendChild(sub2);
          pills.push({ select: select, name: name, combo: { refresh: function (sel, i2) {
            var c = cur();
            hm.l.textContent = 'Màu kim loại: '; hm.v.textContent = c[0];
            hs.l.textContent = 'Màu đá: '; hs.v.textContent = c[1].charAt(0).toUpperCase() + c[1].slice(1);
            lm.buttons.forEach(function (b) {
              var m = b.getAttribute('data-value'), on = m === c[0];
              b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
              b.classList.toggle('is-out', !vals.some(function (x, i) { return parts[i][0] === m && availableWith(i2, x, sel); }));
            });
            ls.buttons.forEach(function (b) {
              var st = b.getAttribute('data-value'), on = st === c[1], k = key[c[0] + '|' + st];
              b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
              b.classList.toggle('is-out', !(k && availableWith(i2, k, sel)));
            });
          } } });
          return;
        }
      }

      /* 3. Bỏ phần chữ lặp ở mọi nút ("Dây chữ A" -> "A", tên nhóm thành "Chữ"). */
      var shown = vals.slice(), showName = name;
      if (!isColor && vals.length >= 4) {
        var words = vals.map(function (x) { return x.trim().split(/\s+/); }), k = 0;
        while (words.every(function (ws) { return ws.length > k + 1 && ws[k] === words[0][k]; })) k++;
        if (k > 0) {
          shown = words.map(function (ws) { return ws.slice(k).join(' '); });
          var lastW = words[0][k - 1]; showName = lastW.charAt(0).toUpperCase() + lastW.slice(1);
        }
      }
      var items = vals.map(function (x, i) {
        var it = { key: x, text: shown[i] };
        if (isColor) {
          it.dot = dotEl(x);
          if (!it.dot) { for (var q = 0; q < data.variants.length; q++) { if (data.variants[q].options[idx] === x && data.variants[q].img) { it.img = data.variants[q].img; break; } } }
        }
        return it;
      });
      var numeric = items.every(function (it) { return /^\d+(\.\d+)?$/.test(it.text.trim()); });
      /* 4. Size là số thì xếp tăng dần. */
      if (numeric) items.sort(function (p1, p2) { return parseFloat(p1.text) - parseFloat(p2.text); });
      var hd = makeHead();
      if (/^size$/i.test(name) && numeric) {
        var g = document.createElement('a');
        g.className = 'lp-opt__guide'; g.href = '/pages/how-to-measure-ring-size'; g.textContent = 'Cách đo size';
        g.addEventListener('click', function (e) { e.preventDefault(); openSizeGuide(g.href); });
        hd.head.appendChild(g);
      }
      var mk = makeList(showName, items, isColor, function (x) { choose(select, x); });
      box.appendChild(hd.head); box.appendChild(mk.list);
      var map = {}; vals.forEach(function (x, i) { map[x] = shown[i]; });
      pills.push({ select: select, name: showName, label: hd.l, value: hd.v, buttons: mk.buttons, show: function (x) { return map[x] || x; } });
    });
    refresh();
    return true;
  };
  if (form) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (buildPills() || tries > 60) clearInterval(timer);
    }, 100);
  }

  /* ---------- 2b. Ý nghĩa + khắc tên (snippet lamy-pdp-info) ---------- */
  var meaning = document.querySelector('[data-lp-meaning]');
  var priceBox = form ? form.querySelector('.price-box-1') : document.querySelector('.product-details-des .price-box-1');
  if (meaning && priceBox) priceBox.parentNode.insertBefore(meaning, priceBox.nextSibling);
  var eg = form ? form.querySelector('[data-lp-engrave]') : null;
  var qtyBox = form ? form.querySelector('.quantity-cart-box') : null;
  /* Màu khác: đặt trên ô chọn Size (hoặc trên ô số lượng nếu không có tuỳ chọn). */
  var sib = document.querySelector('[data-lp-sib]');
  if (sib) {
    var optBox = form ? form.querySelector('.product-variant-option') : null;
    if (optBox && data && data.variants && data.variants.length > 1) optBox.parentNode.insertBefore(sib, optBox);
    else if (qtyBox) qtyBox.parentNode.parentNode.insertBefore(sib, qtyBox.parentNode);
    else if (priceBox) priceBox.parentNode.insertBefore(sib, (meaning || priceBox).nextSibling);
  }
  if (eg && qtyBox) qtyBox.parentNode.parentNode.insertBefore(eg, qtyBox.parentNode);
  var egOn = eg ? eg.querySelector('[data-lp-engrave-on]') : null;
  var egText = eg ? eg.querySelector('[data-lp-engrave-text]') : null;
  var egBody = eg ? eg.querySelector('[data-lp-engrave-body]') : null;
  var egErr = eg ? eg.querySelector('[data-lp-engrave-err]') : null;
  var egCount = eg ? eg.querySelector('[data-lp-engrave-count]') : null;
  var egActive = function () { return !!(egOn && egOn.checked); };
  var egValid = function () {
    if (!egActive()) return true;
    var ok = egText.value.trim().length > 0;
    egErr.hidden = ok;
    eg.classList.toggle('is-err', !ok);
    if (!ok) { eg.scrollIntoView({ behavior: 'smooth', block: 'center' }); egText.focus({ preventScroll: true }); }
    return ok;
  };
  var feeItem = function () {
    var qty = form.querySelector('[name="quantity"]');
    var sel = form.querySelector('[name="id"]');
    var vt = sel && sel.options ? sel.options[sel.selectedIndex].text.split(' - ')[0] : '';
    var name = (document.querySelector('.product-name') || {}).textContent || '';
    return {
      id: parseInt(eg.getAttribute('data-fee-id'), 10),
      quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1),
      properties: { 'Cho sản phẩm': name.trim() + (vt && vt !== 'Default Title' ? ' — ' + vt : ''), 'Nội dung khắc': egText.value.trim() }
    };
  };
  var addFee = function () {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [feeItem()] })
    });
  };
  if (eg) {
    egOn.addEventListener('change', function () {
      egBody.hidden = !egOn.checked;
      egText.disabled = !egOn.checked;
      eg.classList.toggle('is-on', egOn.checked);
      if (egOn.checked) egText.focus();
      else { egErr.hidden = true; eg.classList.remove('is-err'); }
    });
    egText.addEventListener('input', function () {
      egCount.textContent = egText.value.length + '/' + eg.getAttribute('data-max');
      if (egText.value.trim()) { egErr.hidden = true; eg.classList.remove('is-err'); }
    });
    /* Thêm vào giỏ: kiểm tra nội dung, rồi thêm phí khắc trước sản phẩm chính (theme gửi kèm properties[Khắc tên] từ form). */
    var wrapAdd = function () {
      if (!window.Shopify || !Shopify.addItemFromFormStart || Shopify.addItemFromFormStart.lpWrapped) return;
      var orig = Shopify.addItemFromFormStart;
      Shopify.addItemFromFormStart = function (formId) {
        var self = this, args = arguments;
        if (formId !== 'AddToCartForm' || !egActive()) return orig.apply(self, args);
        addFee().then(function () { orig.apply(self, args); }, function () { orig.apply(self, args); });
      };
      Shopify.addItemFromFormStart.lpWrapped = true;
    };
    var atc = document.getElementById('AddToCart');
    if (atc) atc.addEventListener('click', function (e) {
      if (!egValid()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      wrapAdd();
    }, true);
    /* Mua ngay: khi có khắc tên, tự thêm cả hai vào giỏ rồi sang thanh toán. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.shopify-payment-button');
      if (!b || !form.contains(b) || !egActive()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!egValid()) return;
      var sel = form.querySelector('[name="id"]');
      var main = { id: parseInt(sel.value, 10), quantity: feeItem().quantity, properties: { 'Khắc tên': egText.value.trim() } };
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [feeItem(), main] })
      }).then(function () { window.location.href = '/checkout'; });
    }, true);
  }

  /* ---------- 3. Thanh mua dính dưới màn hình ---------- */
  var bar = document.querySelector('[data-lp-sticky]');
  var mainBox = form ? form.querySelector('.quantity-cart-box') || form : null;
  if (bar && mainBox) {
    var past = null;
    var check = function () {
      var r = mainBox.getBoundingClientRect();
      var now = r.bottom < 0;
      if (now === past) return;
      past = now;
      bar.classList.toggle('is-on', now);
      bar.setAttribute('aria-hidden', now ? 'false' : 'true');
      document.body.classList.toggle('lp-sticky-on', now);
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
    var addBtn = bar.querySelector('[data-lp-sticky-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      var real = document.getElementById('AddToCart');
      if (real && !real.disabled) { real.click(); }
      else if (form) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  /* ---------- 3b. "Đã xem gần đây": bỏ chính sản phẩm đang xem, không còn gì thì ẩn cả mục ---------- */
  var recent = document.getElementById('recently-viewed-products');
  if (recent) {
    var here = location.pathname.replace(/\/$/, '');
    var prune = function () {
      recent.querySelectorAll('.product-item').forEach(function (it) {
        var a = it.querySelector('a[href*="/products/"]');
        if (a && a.getAttribute('href').split('?')[0].replace(/\/$/, '') === here) it.remove();
      });
      var sec = recent.closest('section') || recent;
      sec.style.display = recent.querySelector('.product-item') ? '' : 'none';
    };
    prune();
    if (window.MutationObserver) new MutationObserver(prune).observe(recent, { childList: true });
  }

  /* ---------- 4. Khi đổi phân loại (gọi từ selectCallback của theme) ---------- */
  /* Lần gọi đầu do theme tự chọn phân loại mặc định khi tải trang: không nhảy ảnh. */
  var lpUser = false;
  if (form) form.addEventListener('change', function (e) { if (e.isTrusted) lpUser = true; }, true);
  window.lpOnVariant = function (variant) {
    if (!variant) return;
    if (lpUser && variant.featured_media && window.lpGal) window.lpGal.goMedia(variant.featured_media.id);
    if (bar) {
      var p = bar.querySelector('[data-lp-sticky-price]');
      var n = bar.querySelector('[data-lp-sticky-var]');
      var im = bar.querySelector('[data-lp-sticky-img]');
      if (p) p.textContent = money(variant.price);
      if (n && variant.title && variant.title !== 'Default Title') n.textContent = variant.title;
      if (im && variant.featured_image && variant.featured_image.src) {
        var s = variant.featured_image.src;
        im.src = s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }
      var b = bar.querySelector('[data-lp-sticky-add]');
      if (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? 'Thêm vào giỏ' : 'Tạm hết';
      }
    }
    refresh();
  };
})();
